import {React, observer, observable, computed, IDisposer, useEffect, classNames, useAsObservableSource, InfiniteScroll, action} from '@api'
import {Accordion, AccordionDetails, AccordionSummary, Typography} from '@material-ui/core'
import {ExpandMore} from '@material-ui/icons'
import {ChangeLogFlexLayoutTabStore, ChangeLogItems, ICatalogItemChangeEvent, useChangeLogFlexLayoutTabStore, useVipLocalStore, VipLocalStore} from '@modules'
import {ICatalogItemChangeEventRaw, StoresInstance} from '@stores'
import {when} from 'mobx'
import * as css from './ChangeLogAccordion.css'
import {GroupedChangeLogItemsForAccordion} from './entries'

/// region Store

export class ChangeLogAccordionStore extends VipLocalStore {
  constructor(stores: StoresInstance, public root: ChangeLogFlexLayoutTabStore, public props: Omit<MyProps, 'className'>) {
    super(stores)
    const {catalog, index} = this
    this.expanded = catalog.settings.changelog.expanded[index] ?? this.props.expanded
  }

  get index() { return this.props.index }

  @observable expanded: boolean = false

  @observable everExpanded = false

  get title() { return this.props.title }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = [
      when(() => this.expanded === true, () => this.everExpanded = true)
    ]

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  // @computed get hasMore() {
  //   const {root} = this
  //   return root.hasMore && this.is
  // }

  @action toggleExpanded = () => {
    const {expanded, catalog: {settings}, index} = this
    this.expanded = expanded !== true
    settings.changelog.expanded[index] = this.expanded
  }

  @computed get changeEvents(): Array<ICatalogItemChangeEvent> {
    const {root: {_groupedChangeLog, shouldApplyFilters, filteredFields}, title} = this
    const r = _groupedChangeLog[title]
    if (shouldApplyFilters && !_.isEmpty(filteredFields)) {
      return (r ?? []).filter(v => v._log.changes.some(({field}) => filteredFields.has(field)))
    }

    return r
  }
}

export const ChangeLogAccordionStoreContext = React.createContext<ChangeLogAccordionStore>(null)
export const useChangeLogAccordionStore = () => React.useContext(ChangeLogAccordionStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string,
  title: string
  expanded?: boolean
  index: number
}

export const ChangeLogAccordion = observer<MyProps>(function ChangeLogAccordion({className, ...props}) {
  const rootStore = useChangeLogFlexLayoutTabStore(),
    obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new ChangeLogAccordionStore(stores, rootStore, obsProps)),
    {everExpanded, title, changeEvents, expanded, toggleExpanded, root: {newLook, loadPage}} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <ChangeLogAccordionStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>
        <Accordion expanded={expanded} elevation={0}>
          <div className={css.stickyAccordionHeader}>
            <AccordionSummary onDoubleClick={toggleExpanded}
                              expandIcon={<ExpandMore />}
                              IconButtonProps={{onClick: toggleExpanded}}
                              classes={{root: css.accordionRoot, expandIcon: css.expandIcon, expanded: css.expanded, content: css.summaryContent}}>
              <Typography>{title}<span className={css.count}>({changeEvents.length.toLocaleString()})</span></Typography>
            </AccordionSummary>
          </div>
          <AccordionDetails className={css.accordionDetailsRoot}>
            {everExpanded &&
             (newLook ?
             <GroupedChangeLogItemsForAccordion/> :
             <InfiniteScroll
               className={classNames(css.infiniteScroll)}
               pageStart={0}
               useWindow={false}
               loadMore={loadPage}
               initialLoad={false}
               hasMore={rootStore.hasMore}
               // loader={<Spinner className={css.loader} key='spinner' size={20}/>}
             >
               {changeEvents.map((item, i) => {
                 // const id = catalog.idFor(item)
                 return <ChangeLogItems key={i} item={item} index={i}/>
               })}
             </InfiniteScroll>)}
          </AccordionDetails>
        </Accordion>
      </div>
    </ChangeLogAccordionStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/changelog/ChangeLogAccordion.tsx